<template>
	<div class="display-flex tool-header">
		<ToolHeaderTitle />
		<h1 class="med">&nbsp;in&nbsp;</h1>
		<ToolPlacementHeader :toolPlacementId="toolPlacementId" />
	</div>
</template>

<script>
import ToolHeaderTitle from './ToolHeaderTitle.vue';
import ToolPlacementHeader from './ToolPlacementHeader.vue';

export default {
	name: 'ToolHeader',
	props: { toolPlacementId: { type: String } },
	components: { ToolPlacementHeader, ToolHeaderTitle },
};
</script>

<style lang="scss" scoped></style>
